import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { getDateFormat, getTimeFormat } from "../../../../../utils/CommonUtils";
import classes from "./ParkingDurationItem.module.css";

const ParkingDurationItem = (props) => {
  const entranceDate = getDateFormat(new Date(props.entranceDate));
  const entranceTime = getTimeFormat(new Date(props.entranceDate), props.siteTimeZone);
  const retrievalDate = getDateFormat(new Date(props.retrievalDate));
  const retrievalTime = getTimeFormat(new Date(props.retrievalDate), props.siteTimeZone);

  return (
    <div className={classes.parkingItem}>
      <div className={classes.dateTime}>
        <div className={classes.date}>{entranceDate}</div>
        <div className={classes.time}>{entranceTime}</div>
      </div>
      <ArrowRightAltIcon className={classes.arrow} />
      {props.retrievalDate && (
        <div className={classes.dateTime}>
          <div className={classes.date}>{retrievalDate}</div>
          <div className={classes.time}>{retrievalTime}</div>
        </div>
      )}
    </div>
  );
};

export default ParkingDurationItem;
